import React from 'react';
import PoiTypeIcon from 'components/icons/PoiTypeIcon';
import PoiType from 'models/PoiType';
import Link from 'next/link';
import Destination from 'models/Destination';
import { pluralizePoiType } from 'data/pluralize';

function PoiTypePill({ destination, poiType }: { destination: Destination; poiType: PoiType }) {
    return (
        <>
            <Link
                href={`/ideje/${destination.slug}/?filters=${encodeURIComponent('poi-type:' + poiType.slug)}`}
                className="cursor-pointer shadow-xl rounded-3xl min-w-[100px] md:min-w-[130px] flex md:gap-3 gap-2 px-6 py-2"
            >
                <PoiTypeIcon slug={poiType.slug} size="30px" />
                <div>
                    <p className="text-sm font-bold leading-4 mb-0">{pluralizePoiType(poiType.slug)}</p>
                    <p className="text-xs font-light leading-[18px]">{poiType.pois_count} idej</p>
                </div>
            </Link>
        </>
    );
}

export default PoiTypePill;
